import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './RoundButton.scss';

const RoundButton = ({
  radius, children, className, onClick,
}) => {
  const roundButtonClasses = classNames({
    'round-button': true,
    [`${className}`]: true,
  });
  return (
    <button onClick={onClick} type="button" style={{ width: radius }} className={roundButtonClasses}>
      {children}
    </button>
  );
};

RoundButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  radius: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
RoundButton.defaultProps = {
  radius: '20px',
  className: '',
  onClick: () => {},
};
export default RoundButton;



// WEBPACK FOOTER //
// ./src/components/_atomic/RoundButton/RoundButton.js